import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const USER_RENAME = gql(`
  mutation userRename($fullName: String!) {
    userRename(fullName: $fullName) {
      __typename
      ... on User {
        __typename
        id
        fullName
      }
    }
  }
`);

export function useUserRename() {
  return useMutation(USER_RENAME);
}
